import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const ProjectsLink = ({ ...props }) => (
  <Link route="projects/index" params={{ slug: getOrgSlug() }} {...props} />
);

export const ArchivedProjectsLink = ({ ...props }) => (
  <Link route="projects/archived" params={{ slug: getOrgSlug() }} {...props} />
);

export const ProjectLink = ({ projectId, ...props }) => (
  <Link
    route="projects/show"
    params={{ projectId, slug: getOrgSlug() }}
    {...props}
  />
);

export const NewProjectLink = ({ portfolioId, ...props }) => {
  const params = { slug: getOrgSlug() };
  if (portfolioId) params.portfolioId = portfolioId;
  return (
    <AuthorizedAction action="create" subject="project">
      <Link route="projects/new" params={params} {...props} />
    </AuthorizedAction>
  );
};

export const EditProjectLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="update" subject="project">
    <Link
      route="projects/edit"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const ProjectFilesLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="read" subject="linkedFile">
    <Link
      route="projects/files"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const ProjectStakeholdersLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="read" subject="stakeholder">
    <Link
      route="projects/stakeholders"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const ChangeStrategiesLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="read" subject="changeImpact">
    <Link
      route="projects/change-strategy"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditChangeStrategyLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="update" subject="changeImpact">
    <Link
      route="projects/change-strategy/edit/step-general"
      params={{
        projectId,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);
